<template>
  <div>
    <vetster-auth-register
      v-if="[AuthFormType.Register, AuthFormType.Socialite].includes(mode)"
      :email="email"
      :is-socialite="mode === AuthFormType.Socialite"
      :is-partner="isPartner"
      :is-booking="isBooking"
      :promo-code="promoCode"
      :is-locale-read-only="isLocaleReadOnly"
      :is-promo-code-readonly="isPromoCodeReadonly"
      :is-promo-code-required="isPromoCodeRequired"
      :redirect-to-dashboard="redirectToDashboard"
      :global-locale="globalLocale"
      :variant="variant"
      :promo-code-label="promoCodeLabel"
      @action-completed="passThroughEvent"
    />
    <vetster-auth-login
      v-else
      :redirect-to-dashboard="redirectToDashboard"
      :show-social="showSocial"
      :title="titleLogin"
      :variant="variant"
      @register="saveEmail"
      @action-completed="passThroughEvent"
    />
  </div>
</template>

<script>
import VetsterAuthLogin from '@/brand-components/VetsterAuthLogin';
import VetsterAuthRegister from '@/brand-components/VetsterAuthRegister';
import AuthFormType from '@/enums/AuthFormType';

export default {
  name: 'VetsterAuthForms',

  components: {
    VetsterAuthLogin,
    VetsterAuthRegister,
  },

  props: {
    authMode: {
      default: AuthFormType.PasswordlessLogin,
      type: String,
    },
    isBooking: {
      type: Boolean,
      default: false,
    },
    isLocaleReadOnly: {
      type: Boolean,
      default: false,
    },
    isPartner: {
      default: false,
      type: Boolean,
    },
    isPromoCodeReadonly: {
      default: false,
      type: Boolean,
    },
    isPromoCodeRequired: {
      default: false,
      type: Boolean,
    },
    promoCode: {
      type: String,
      default: '',
    },
    redirectToDashboard: {
      default: false,
      type: Boolean,
    },
    showSocial: {
      default: true,
      type: Boolean,
    },
    titleLogin: {
      type: String,
      default: null,
    },
    globalLocale: {
      default: '',
      type: String,
    },
    variant: {
      default: null,
      type: String,
    },
    promoCodeLabel: {
      default: null,
      type: String,
    },
  },

  data() {
    return {
      AuthFormType,
      email: null,
      mode: null,
    };
  },

  watch: {
    authMode(val) {
      this.mode = val;
    },
  },

  created() {
    this.mode = this.authMode;
  },

  methods: {
    passThroughEvent(event) {
      this.$emit('action-completed', event);
    },
    saveEmail(email) {
      this.email = email;
    },
  },
};
</script>
